var exports = {
  "n": "loadingStatus__uGt0EW",
  "j": "neutralDot__XHXYSY",
};

module.exports = exports;
